export default __webpack_public_path__ + "static/mbStar_logo-79c0e71ae80fc51e0aac5d6c9c6f7d33.png";